import * as ConfigValues from '../../../util/configValues';

export const apiUrl = `${ConfigValues.REACT_APP_API_HOST_NAME}/api`;